export const STATE = {
    OPEN: 1,
    SUBMITTED: 2,
};

export const allStates = [
    {
        id: STATE.OPEN,
        state: 'Open',
        active: 1,
    },
    {
        id: STATE.SUBMITTED,
        state: 'Ingediend',
        active: 1,
    },
];
